function isSiren(siren: string) {
  let isValid;
  if ((siren.length !== 9) || (Number.isNaN(siren))) isValid = false;
  else {
    // Siren is 9 digits
    let sum = 0;
    let tmp: number;
    for (let cpt = 0; cpt < siren.length; cpt += 1) {
      if ((cpt % 2) === 1) { // pair digit for : 2nd, 4th, 6th et 8th digit
        tmp = Number(siren.charAt(cpt)) * 2;
        if (tmp > 9) tmp -= 9; // If tmp > 10 substract 9 to have digit between 1 and 9
      } else tmp = parseInt(siren.charAt(cpt), 10);
      sum += tmp;
    }
    if ((sum % 10) === 0) isValid = true; // If siren is a multiple of 10 so correct
    else isValid = false;
  }
  return isValid;
}

function isSiret(siret: string) {
  let isValid;
  if ((siret.length !== 14) || (Number.isNaN(siret))) isValid = false;
  else {
    let sum = 0;
    let tmp: number;
    for (let cpt = 0; cpt < siret.length; cpt += 1) {
      if ((cpt % 2) === 0) { // impair digit : 1st, 3th, 5th, etc...
        tmp = Number(siret.charAt(cpt)) * 2;
        if (tmp > 9) tmp -= 9; // If tmp > 10 substract 9 to have digit between 1 and 9
      } else tmp = parseInt(siret.charAt(cpt), 10);
      sum += tmp;
    }
    if ((sum % 10) === 0) isValid = true; // If siret is a multiple of 10 so correct
    else isValid = false;
  }
  return isValid;
}

export {
  isSiren, isSiret,
};
